/**
 * Session Management Tab
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SessionManagementSettingsState = {
  sessionManagementSettings: {},
  sessionManagementSettingsLoading: false,
}

export const SessionManagementSettingsActions = {
  createSessionManagementSettings: async ({ commit }, value) => {
    commit('setSessionManagementSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'sessionManagement',
        value,
      }).
      then(({ data }) => {
        commit('setSessionManagementSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setSessionManagementSettingsLoading', false))
  },

  deleteSessionManagementSettings: async ({ getters, commit }) => {
    commit('setSessionManagementSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.sessionManagementSettingsId}`).
      then(({ data }) => {
        commit('setSessionManagementSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setSessionManagementSettingsLoading', false))
  },

  getSessionManagementSettings: async ({ commit }) => {
    commit('setSessionManagementSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/sessionManagement').
      then(({ data }) => {
        commit('setSessionManagementSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setSessionManagementSettingsLoading', false))
  },

  updateSessionManagementSettings: async ({ getters, commit }, value) => {
    commit('setSessionManagementSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.sessionManagementSettingsId}`, {
        name: 'sessionManagement',
        value,
      }).
      then(({ data }) => {
        commit('setSessionManagementSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setSessionManagementSettingsLoading', false))
  },
}

export const SessionManagementSettingsMutations = {
  setSessionManagementSettings: (state, payload) => {
    state.sessionManagementSettings = payload
  },
  setSessionManagementSettingsLoading: (state, payload) => {
    state.sessionManagementSettingsLoading = payload
  },
  setSessionManagementSettingsValue: (state, payload) => {
    state.sessionManagementSettings.value = payload
  },
}

export const SessionManagementSettingsGetters = {
  sessionManagementSettings: state => state.sessionManagementSettings,
  sessionManagementSettingsId: state => state.sessionManagementSettings?.id,
  sessionManagementSettingsLoading: state => state.sessionManagementSettingsLoading,
  sessionManagementSettingsValue: state => state.sessionManagementSettings?.value,
}
